// Central color variables for the frontend
export const PRIMARY_COLOR = '#5C6C4B';
